import { Suspense } from "react";
import { MatxLoading } from "app/components";

// export default function MatxSuspense({ children }) {
//   return <Suspense fallback={<MatxLoading />}>{children}</Suspense>;
// }

const MatxSuspense = ({ children, fallback = <MatxLoading /> }) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};
export default MatxSuspense;
